import React from 'react';
import PosOpenOrderingCheckoutPage from '../modules/posRestaurant/components/PosOpenOrderingCheckoutPage';

/**
 * Route wrapper for `/pos-restaurant/open/checkout/`.
 * Implementation lives in modules — keep this file as a thin re-export so UI changes apply consistently.
 */
const PosOpenOrderingCheckoutPublicPage = () => <PosOpenOrderingCheckoutPage />;

export default PosOpenOrderingCheckoutPublicPage;
